import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/legal-pages.css';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-page-container">
        <h1 className="legal-page-title">Messaging Privacy Policy</h1>
        
        <p className="legal-page-date"><strong>Effective Date:</strong> 10/01/2025</p>
        
        <p className="legal-page-intro">
          Muse Legal Group, P.C. ("we," "us," "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how Muse Legal Group, P.C. collects and uses information about you when you opt-in to receive SMS messages from us.
        </p>

        <section className="legal-section">
          <h2>Our Commitment to Your Privacy</h2>
          <p>
            We are committed to protecting your privacy. Consumer data, including mobile information, is collected and used solely for business operations and to provide our services. Your data will not be shared with third parties for marketing purposes and will not be transferred to external organizations.
          </p>
          <p>We collect and use your information as follows:</p>
          <ul>
            <li>To operate and improve our services</li>
            <li>To communicate with you regarding your account or our services</li>
            <li>To comply with legal obligations</li>
          </ul>
          <p>
            We implement strict measures to prevent unauthorized access, sharing, or disclosure of your personal data.
          </p>
          <p>
            You have the right to opt out of our messaging campaigns at any time. To do so, please follow the instructions provided in our messages or contact us directly.
          </p>
          <p>
            For any questions or to exercise your rights, please contact us at: <a href="mailto:admin@muselegalgroup.com" className="legal-link">admin@muselegalgroup.com</a>.
          </p>
        </section>

        <section className="legal-section">
          <h2>Information We Collect</h2>
          <p>When you opt-in to receive SMS messages, we collect:</p>
          <ul>
            <li>Your phone number</li>
            <li>Consent to send SMS messages</li>
            <li>Your email address</li>
            <li>Your basic contact information</li>
            <li>Your messaging history</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>How We Collect Your Information</h2>
          <p>
            We may collect your information directly from you, such as when you complete a form or contact us or automatically, such as when you interact with our website.
          </p>
        </section>

        <section className="legal-section">
          <h2>How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Send you the SMS messages you've opted in to receive</li>
            <li>Provide updates, promotions, or other relevant content based on your preferences</li>
            <li>Choices and Controls</li>
            <li>To operate our business</li>
          </ul>
          <p>
            You can opt out of receiving SMS messages at any time by replying STOP to any message we send you. You can review our <Link to="/terms-and-conditions" className="legal-link">Terms and Conditions</Link> for additional information about the opt-out process.
          </p>
        </section>

        <section className="legal-section">
          <h2>To Whom We Disclose Your Information</h2>
          <p>
            We may disclose your information to our affiliated companies; to third party service providers, business advisors, or consultants who provide services to us; in connection with a merger, acquisition, reorganization, restructuring, financing transaction or sale of assets; as required by law or administrative order; to assert claims or rights or to defend against claims.
          </p>
          <p>
            We do not share your personal information, phone number, or SMS consent opt-in data with third parties or affiliates for marketing or promotional purposes.
          </p>
        </section>

        <section className="legal-section">
          <h2>Protection of Information</h2>
          <p>
            We take steps to protect your information against unauthorized use or disclosure.
          </p>
        </section>

        <section className="legal-section">
          <h2>Updates</h2>
          <p>
            We may periodically update this privacy policy. If we make material changes that have a substantive and adverse impact on your privacy, we will provide notice on this website prior to the change becoming effective. We encourage you to periodically review this page for the latest information about our privacy practices.
          </p>
        </section>

        <section className="legal-section">
          <h2>How to Contact Us</h2>
          <p>
            You can reach us by texting the word HELP for support to <a href="tel:8182458888" className="legal-link">(818) 245-8888</a>. You may also contact us directly at <a href="mailto:admin@muselegalgroup.com" className="legal-link">admin@muselegalgroup.com</a>.
          </p>
        </section>

        <div className="legal-page-footer">
          <Link to="/" className="legal-back-link">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;

